import { useTranslation } from 'react-i18next'
import { Form } from '~/entities/Debt/ui/CashModal/Form'
import { Modal } from '~/shared/ui/Modal'
import { FormValues } from './model'

type CashModalProps = {
  isShow: boolean
  onOk: (formValues: FormValues) => void
  onCancel: () => void
  isSubmitting: boolean
}

export function CashModal({
  isShow,
  onOk,
  onCancel,
  isSubmitting,
}: CashModalProps) {
  const { t } = useTranslation()
  return (
    <Modal
      isShow={isShow}
      onCancel={isSubmitting ? undefined : onCancel}
      title={t('deposit funds')}
      dialogProps={{
        sx: {
          minWidth: '600px',
          maxWidth: '600px',
        },
      }}
    >
      <Form onSuccess={onOk} isSubmitting={isSubmitting} />
    </Modal>
  )
}
